/* ==========================================================================
   ORDER FORM
   Three services on one form.

     Writing   -> priced live, goes to Shopify Checkout
     Technical -> priced live, goes to Shopify Checkout
     Online Class -> emailed to the store owner via Shopify's contact form,
                     because a term of coursework has to be quoted by hand

   The markup is a Shopify contact form. With JavaScript on, the two paid
   services are upgraded to a real checkout. With JavaScript off, every
   service falls back to sending an enquiry email, so the form never dies.

   Pricing config arrives from the section schema as window.OF_CONFIG.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.OF_CONFIG || {};
  var form = document.getElementById('of-form');
  if (!form) return;

  var $ = function (s, r) { return (r || form).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || form).querySelectorAll(s)); };

  var service = CFG.defaultService || 'writing';

  var RATES = {
    writing: Number(CFG.rateWriting) || 12,
    technical: Number(CFG.rateTechnical) || 15
  };
  var LEVELS = {
    highschool: 1.00,
    undergraduate: 1.15,
    masters: 1.45,
    doctoral: 1.80
  };
  var LEVEL_LABEL = {
    highschool: 'High school',
    undergraduate: 'Undergraduate',
    masters: 'Master\u2019s',
    doctoral: 'Doctoral / PhD'
  };
  /* hours remaining -> multiplier */
  var URGENCY = [
    { h: 24, m: 1.80, label: 'Under 24 hours' },
    { h: 48, m: 1.55, label: '1\u20132 days' },
    { h: 72, m: 1.40, label: '2\u20133 days' },
    { h: 168, m: 1.15, label: '3\u20137 days' },
    { h: 336, m: 1.00, label: '1\u20132 weeks' },
    { h: Infinity, m: 0.88, label: 'Over 2 weeks' }
  ];
  var WORDS_PER_PAGE = Number(CFG.wordsPerPage) || 250;
  var MIN_ORDER = Number(CFG.minOrder) || 20;

  /* Online class deposit. One week upfront is the floor for any class. */
  var WEEK_RATES = CFG.weekRates || { standard: 50, priority: 65, advanced: 80 };
  var PRIORITY_FEE = Number(CFG.priorityFee) || 25;
  var TIER_LABEL = {
    standard: 'Standard',
    priority: 'Priority',
    advanced: 'Advanced'
  };

  /* ---------------------------------------------------------------- utils */

  function money(n) {
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function deadlineDate() {
    var d = $('#of-deadline-date');
    var t = $('#of-deadline-time');
    if (!d || !d.value) return null;
    var parts = d.value.split('-');
    if (parts.length !== 3) return null;
    var hh = t && t.value ? parseInt(t.value, 10) : 16;
    return new Date(+parts[0], +parts[1] - 1, +parts[2], hh, 0, 0);
  }

  function hoursLeft() {
    var d = deadlineDate();
    if (!d) return null;
    return (d.getTime() - Date.now()) / 36e5;
  }

  function urgencyFor(h) {
    if (h === null) return URGENCY[3];
    for (var i = 0; i < URGENCY.length; i++) if (h < URGENCY[i].h) return URGENCY[i];
    return URGENCY[URGENCY.length - 1];
  }

  function pages() {
    var v = parseInt(($('#of-pages') || {}).value, 10);
    return isNaN(v) || v < 1 ? 1 : Math.min(v, 500);
  }

  function level() {
    var s = $('#of-level');
    return (s && s.value) || 'undergraduate';
  }

  /* ------------------------------------------------------------- quoting */

  var ADDON_LABEL = {
    enl: 'Top ENL Writer',
    esl: 'Top ESL Writer',
    reports: 'Turnitin AI & Plagiarism Reports',
    updates: 'Hourly updates',
    qa: 'QA check before submission'
  };

  function addons() {
    var out = [], total = 0;
    $$('[data-of-addon]').forEach(function (el) {
      if (!el.checked) return;
      var price = Number(el.getAttribute('data-of-price')) || 0;
      var key = el.getAttribute('data-of-addon');
      out.push({ key: key, label: ADDON_LABEL[key] || key, price: price });
      total += price;
    });
    return { list: out, total: total };
  }

  function quote() {
    if (service === 'onlineclass') return null;
    var h = hoursLeft();
    var u = urgencyFor(h);
    var lv = level();
    var perPage = RATES[service] * (LEVELS[lv] || 1) * u.m;
    var total = perPage * pages();
    if (total < MIN_ORDER) total = MIN_ORDER;
    /* Add-ons are flat fees on top of the page-rate calculation, and are
       applied after the minimum so a small order still pays for them. */
    var add = addons();
    total += add.total;
    /* The cart carries the price as a quantity of $1.00 units, so the total
       has to be a whole number of dollars. Round here, not at checkout, or
       the customer is quoted one figure and charged another. */
    total = Math.max(1, Math.round(total));
    return {
      perPage: perPage,
      total: total,
      urgency: u,
      level: lv,
      pages: pages(),
      hours: h,
      addons: add.list,
      addonTotal: add.total
    };
  }

  function tier() {
    var t = $('#of-tier');
    return (t && t.value) || 'standard';
  }
  function weeks() {
    var v = parseInt(($('#of-weeks') || {}).value, 10);
    return isNaN(v) || v < 1 ? 1 : Math.min(v, 20);
  }
  function priorityOn() {
    var c = $('#of-priority');
    return !!(c && c.checked);
  }

  function depositQuote() {
    var rate = Number(WEEK_RATES[tier()]) || 50;
    var w = weeks();
    var addon = priorityOn() ? PRIORITY_FEE : 0;
    /* Whole dollars, because the cart carries the price as a quantity. */
    var total = Math.max(1, Math.round(rate * w + addon));
    return { rate: rate, weeks: w, addon: addon, total: total, tier: tier() };
  }

  function paintDeposit() {
    var box = $('#of-deposit');
    if (!box) return;
    var q = depositQuote();
    $('#of-d-rate').textContent = money(q.rate) + ' / week \u00b7 ' + (TIER_LABEL[q.tier] || q.tier);
    $('#of-d-weeks').textContent = q.weeks + ' week' + (q.weeks === 1 ? '' : 's');
    $('#of-d-priority').textContent = q.addon ? 'Added \u2014 ' + money(q.addon) : 'Not added';
    $('#of-d-total').textContent = money(q.total);
    var out = $('#of-weeks-out');
    if (out) out.textContent = q.weeks + ' week' + (q.weeks === 1 ? '' : 's');
    var minus = $('#of-weeks-minus');
    if (minus) minus.disabled = q.weeks <= 1;
  }

  function paintQuote() {
    var box = $('#of-quote');
    if (!box) return;
    if (service === 'onlineclass') { box.style.display = 'none'; return; }
    box.style.display = '';
    var q = quote();
    $('#of-q-service').textContent = service === 'writing' ? 'Writing' : 'Technical';
    $('#of-q-level').textContent = LEVEL_LABEL[q.level] || q.level;
    $('#of-q-pages').textContent = q.pages + ' page' + (q.pages === 1 ? '' : 's')
      + ' \u00b7 ' + (q.pages * WORDS_PER_PAGE).toLocaleString('en-US') + ' words';
    $('#of-q-urgency').textContent = q.urgency.label
      + (q.urgency.m === 1 ? '' : ' (\u00d7' + q.urgency.m.toFixed(2) + ')');
    $('#of-q-rate').textContent = money(q.perPage) + ' / page';
    $('#of-q-total').textContent = money(q.total);
    var row = $('#of-q-addon-row'), cell = $('#of-q-addons');
    if (row && cell) {
      if (q.addons.length) {
        row.style.display = '';
        cell.textContent = q.addons.map(function (a) { return a.label; }).join(', ') +
          '  (+' + money(q.addonTotal) + ')';
      } else {
        row.style.display = 'none';
      }
    }
    var note = $('#of-q-note');
    if (note) {
      note.textContent = q.total <= MIN_ORDER
        ? 'Minimum order is ' + money(MIN_ORDER) + '.'
        : 'Final price, rounded to the dollar. Nothing is added at checkout.';
    }
  }

  /* --------------------------------------------------------- deadline UI */

  function paintCountdown() {
    var out = $('#of-countdown');
    if (!out) return;
    var h = hoursLeft();
    if (h === null) { out.textContent = ''; out.classList.remove('is-rush'); return; }
    if (h <= 0) {
      out.textContent = '(that date has passed)';
      out.classList.add('is-rush');
      return;
    }
    var txt;
    if (h < 24) txt = '(' + Math.max(1, Math.round(h)) + ' hours left)';
    else txt = '(' + Math.floor(h / 24) + ' days left)';
    out.textContent = txt;
    out.classList.toggle('is-rush', h < 48);
  }

  /* ----------------------------------------------------------- stepper UI */

  function paintPages() {
    var out = $('#of-words');
    if (out) out.textContent = (pages() * WORDS_PER_PAGE).toLocaleString('en-US') + ' Words';
    var minus = $('#of-pages-minus');
    if (minus) minus.disabled = pages() <= 1;
  }

  /* -------------------------------------------------------- service tabs */

  function setService(next) {
    service = next;
    $$('.of-tab').forEach(function (t) {
      t.setAttribute('aria-selected', String(t.dataset.ofService === next));
    });
    $$('[data-of-only]').forEach(function (el) {
      var list = el.dataset.ofOnly.split(/\s+/);
      el.classList.toggle('is-on', list.indexOf(next) > -1);
    });

    var head = $('#of-title');
    var usps = $('#of-usps');
    var copy = CFG.copy && CFG.copy[next];
    if (head && copy) head.textContent = copy.title;
    if (usps && copy) {
      usps.innerHTML = '';
      copy.usps.forEach(function (u) {
        var li = document.createElement('li');
        li.textContent = u;
        usps.appendChild(li);
      });
    }

    var btn = $('#of-submit');
    if (btn) {
      btn.textContent = next === 'onlineclass'
        ? 'Pay Deposit & Reserve My Expert'
        : 'Proceed to Secure Checkout';
      btn.classList.add('of-submit--pay');
    }
    /* The secondary button only exists for the online class, where paying a
       deposit and asking for a hand-built quote are both legitimate paths. */
    var alt = $('#of-submit-alt');
    if (alt) alt.classList.toggle('is-on', next === 'onlineclass');

    var hidden = $('#of-service-field');
    if (hidden) hidden.value = copy ? copy.title : next;

    paintQuote();
    paintDeposit();
    paintPages();
    paintCountdown();
  }

  /* ------------------------------------------------------- validation UI */

  function markFilled(input) {
    var w = input.closest('.of-req');
    if (!w) return;
    var ok = String(input.value || '').trim() !== '';
    w.classList.toggle('is-filled', ok);
    if (ok) w.classList.remove('is-invalid');
  }

  function validate() {
    var bad = null;
    $$('.of-req').forEach(function (w) {
      if (w.offsetParent === null) { w.classList.remove('is-invalid'); return; }
      var input = w.querySelector('input, select, textarea');
      if (!input) return;
      var v = String(input.value || '').trim();
      var ok = v !== '';
      if (ok && input.type === 'email') ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
      w.classList.toggle('is-invalid', !ok);
      if (!ok && !bad) bad = input;
    });
    var consent = $('#of-consent');
    if (consent && !consent.checked) {
      if (!bad) bad = consent;
      var cw = consent.closest('.of-consent');
      if (cw) cw.style.color = '#b3261e';
    }
    if (bad) {
      bad.focus();
      bad.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    return !bad;
  }

  /* ------------------------------------------------------------ checkout */

  function orderProperties(q) {
    var p = {
      'Service': service === 'writing' ? 'Professional writing' : 'Technical assignment',
      'Email': ($('#of-email') || {}).value || '',
      'Phone': (($('#of-country') || {}).value || '') + ' ' + (($('#of-phone') || {}).value || ''),
      'Subject / Course code': ($('#of-subject') || {}).value || '',
      'Academic level': LEVEL_LABEL[q.level] || q.level,
      'Pages': q.pages + ' (' + (q.pages * WORDS_PER_PAGE) + ' words)',
      'Deadline': (($('#of-deadline-date') || {}).value || '') + ' ' + (($('#of-deadline-time') || {}).selectedOptions ? $('#of-deadline-time').selectedOptions[0].text : ''),
      'Turnaround band': q.urgency.label,
      'Rate applied': money(q.perPage) + ' per page \u00d7 ' + q.pages + ' pages',
      'Brief': ($('#of-brief') || {}).value || ''
    };
    if (q.addons && q.addons.length) {
      p['Add-on services'] = q.addons.map(function (a) {
        return a.label + ' (' + money(a.price) + ')';
      }).join(' | ');
      p['Add-on total'] = money(q.addonTotal);
    }
    var ref = 'TMOC-' + Date.now().toString(36).toUpperCase().slice(-6);
    p['Order reference'] = ref;
    return p;
  }

  function depositProperties(q) {
    var p = {
      'Service': 'Online class \u2014 upfront reservation deposit',
      'Email': ($('#of-email') || {}).value || '',
      'Phone': (($('#of-country') || {}).value || '') + ' ' + (($('#of-phone') || {}).value || ''),
      'Subject / Course code': ($('#of-subject') || {}).value || '',
      'School / LMS': ($('#of-lms') || {}).value || '',
      'Course runs': (($('#of-course-start') || {}).value || '?') + ' to ' + (($('#of-course-end') || {}).value || '?'),
      'Current grade': ($('#of-grade') || {}).value || 'Not started',
      'Class tier': (TIER_LABEL[q.tier] || q.tier) + ' \u2014 ' + money(q.rate) + '/week',
      'Weeks prepaid': String(q.weeks),
      'Priority expert check': q.addon ? 'YES \u2014 ' + money(q.addon) + ' (assign senior specialist, pre-review syllabus and rubric)' : 'No',
      'Deposit paid': money(q.total) + ' \u2014 credited against course total',
      'Brief': ($('#of-brief') || {}).value || ''
    };
    p['Order reference'] = 'TMOC-' + Date.now().toString(36).toUpperCase().slice(-6);
    return p;
  }

  function fail(msg) {
    var box = $('#of-live-error');
    if (box) {
      box.textContent = msg;
      box.style.display = 'block';
      box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } else {
      alert(msg);
    }
  }

  function checkout(btn) {
    var variant = CFG.unitVariantId;
    if (!variant) {
      fail('Checkout is not configured yet — the pricing product is missing. '
         + 'Please send your details by email instead, or message us on WhatsApp.');
      btn.classList.remove('is-busy');
      btn.disabled = false;
      return;
    }

    var deposit = service === 'onlineclass';
    var q = deposit ? depositQuote() : quote();
    /* The pricing product costs exactly $1.00, so quantity carries the price.
       Shopify has no native variable-price line item without an app. */
    var units = q.total;

    var fd = new FormData();
    fd.append('id', variant);
    fd.append('quantity', units);

    var props = deposit ? depositProperties(q) : orderProperties(q);
    Object.keys(props).forEach(function (k) {
      if (props[k] && String(props[k]).trim()) fd.append('properties[' + k + ']', props[k]);
    });

    var files = $('#of-files');
    if (files && files.files && files.files.length) {
      /* Shopify accepts one file per line item property. Extra files are
         collected after checkout, and the brief says so. */
      fd.append('properties[Attachment]', files.files[0]);
      if (files.files.length > 1) {
        fd.append('properties[Further files]', files.files.length - 1 + ' more to follow by email');
      }
    }

    /* Start from an empty cart so the quantity-as-price total is exact. */
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .catch(function () { /* a stale cart is survivable */ })
      .then(function () {
        return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Cart rejected the order.'); });
        return r.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        fail('We could not open checkout (' + err.message + '). '
           + 'Your details are safe — press Send instead and we will invoice you directly.');
        btn.classList.remove('is-busy');
        btn.disabled = false;
      });
  }

  /* ---------------------------------------------------------------- wire */

  form.addEventListener('click', function (e) {
    var tab = e.target.closest('.of-tab');
    if (tab) { e.preventDefault(); setService(tab.dataset.ofService); return; }

    var step = e.target.closest('.of-step');
    if (step && step.dataset.ofStep) {
      e.preventDefault();
      var input = $('#of-pages');
      var v = pages() + (step.dataset.ofStep === 'up' ? 1 : -1);
      input.value = Math.max(1, Math.min(500, v));
      paintPages(); paintQuote();
      return;
    }
    if (step && step.dataset.ofWstep) {
      e.preventDefault();
      var wi = $('#of-weeks');
      var wv = weeks() + (step.dataset.ofWstep === 'up' ? 1 : -1);
      wi.value = Math.max(1, Math.min(20, wv));
      paintDeposit();
      return;
    }

    /* Record which button was pressed before the form submits. */
    var sub = e.target.closest('#of-submit, #of-submit-alt');
    if (sub) {
      var intent = $('#of-intent');
      if (intent) intent.value = (sub.id === 'of-submit-alt') ? 'quote' : 'pay';
    }
  });

  form.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches('input, select, textarea')) markFilled(t);
    if (t.hasAttribute && t.hasAttribute('data-of-addon')) paintQuote();
    if (t.id === 'of-pages') { paintPages(); paintQuote(); }
    if (t.id === 'of-weeks') paintDeposit();
    if (t.id === 'of-deadline-date') { paintCountdown(); paintQuote(); }
  });

  form.addEventListener('change', function (e) {
    var t = e.target;
    if (t.id === 'of-level' || t.id === 'of-deadline-time') paintQuote();
    if (t.id === 'of-tier' || t.id === 'of-priority' || t.id === 'of-weeks') paintDeposit();
    if (t.hasAttribute && t.hasAttribute('data-of-addon')) {
      /* A writer is either a native English speaker or not — these two cannot
         both apply, and charging for both would be indefensible. */
      var key = t.getAttribute('data-of-addon');
      if (t.checked && (key === 'enl' || key === 'esl')) {
        var other = $('[data-of-addon="' + (key === 'enl' ? 'esl' : 'enl') + '"]');
        if (other && other.checked) other.checked = false;
      }
      paintQuote();
    }
    if (t.id === 'of-deadline-time') paintCountdown();
    if (t.id === 'of-files') {
      var ul = $('#of-filelist');
      if (!ul) return;
      ul.innerHTML = '';
      Array.prototype.forEach.call(t.files, function (f) {
        var li = document.createElement('li');
        li.textContent = '\u2022 ' + f.name + ' (' + Math.round(f.size / 1024) + ' KB)';
        ul.appendChild(li);
      });
    }
  });

  form.addEventListener('submit', function (e) {
    if (!validate()) { e.preventDefault(); return; }

    var intent = ($('#of-intent') || {}).value || 'pay';

    if (service === 'onlineclass' && intent !== 'pay') {
      /* Quote-first path: Shopify posts the contact form to the store inbox. */
      var body = $('#of-body');
      if (body) body.value = composeEnquiry();
      return;
    }

    e.preventDefault();
    var btn = $('#of-submit');
    btn.classList.add('is-busy');
    btn.disabled = true;
    checkout(btn);
  });

  function composeEnquiry() {
    var lines = [
      'SERVICE: Online class / full course',
      'Subject or course code: ' + (($('#of-subject') || {}).value || '\u2014'),
      'Phone: ' + (($('#of-country') || {}).value || '') + ' ' + (($('#of-phone') || {}).value || ''),
      'School / LMS: ' + (($('#of-lms') || {}).value || '\u2014'),
      'Course runs: ' + (($('#of-course-start') || {}).value || '\u2014') + ' to ' + (($('#of-course-end') || {}).value || '\u2014'),
      'Current grade: ' + (($('#of-grade') || {}).value || '\u2014'),
      'Tier requested: ' + (TIER_LABEL[tier()] || tier()) + ' (' + money(Number(WEEK_RATES[tier()]) || 50) + '/week)',
      'Weeks discussed: ' + weeks(),
      'Priority expert check requested: ' + (priorityOn() ? 'YES' : 'No'),
      'Indicative deposit if they proceed: ' + money(depositQuote().total),
      '',
      'DETAILS:',
      (($('#of-brief') || {}).value || '\u2014')
    ];
    return lines.join('\n');
  }

  /* ------------------------------------------------------------ defaults */

  function seedDeadline() {
    var d = $('#of-deadline-date');
    if (!d) return;
    d.min = new Date().toISOString().slice(0, 10);
    if (!d.value) {
      var t = new Date();
      t.setDate(t.getDate() + 6);
      d.value = t.toISOString().slice(0, 10);
    }
  }

  /* Shopify redirects back to the page after a successful contact post. The
     confirmation is at the top of a long form, so scroll to it and move focus
     there — otherwise the customer lands mid-form and assumes nothing
     happened, which is exactly the doubt the message exists to remove. */
  (function announceSuccess() {
    var ok = document.getElementById('of-success');
    if (!ok) return;
    setTimeout(function () {
      try { ok.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { ok.scrollIntoView(); }
      try { ok.focus({ preventScroll: true }); } catch (e) {}
    }, 120);
    /* Clear the posted flag from the URL so a refresh does not re-show the
       confirmation for an order that was never re-sent. */
    if (window.history && window.history.replaceState && /contact_posted/.test(window.location.search)) {
      try {
        window.history.replaceState({}, '', window.location.pathname + '#of-success');
      } catch (e) {}
    }
  })();

  seedDeadline();
  paintDeposit();
  $$('input, select, textarea').forEach(markFilled);

  var initial = new URLSearchParams(window.location.search).get('service');
  setService(['writing', 'technical', 'onlineclass'].indexOf(initial) > -1 ? initial : service);

  window.OF = { setService: setService, quote: quote, version: '1.0.0' };
})();
